"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upload = void 0;
var noop_1 = require("../_util/noop");
function upload(_a) {
    var action = _a.action, file = _a.file, filename = _a.filename, _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.headers, headers = _c === void 0 ? {} : _c, _d = _a.method, method = _d === void 0 ? "POST" : _d, _e = _a.withCredentials, withCredentials = _e === void 0 ? false : _e, _f = _a.send, send = _f === void 0 ? function (_, data) { return data; } : _f, _g = _a.onProgress, onProgress = _g === void 0 ? noop_1.noop : _g, _h = _a.onSuccess, onSuccess = _h === void 0 ? noop_1.noop : _h, _j = _a.onError, onError = _j === void 0 ? noop_1.noop : _j;
    var formData = new FormData();
    var xhr = new XMLHttpRequest();
    xhr.onload = function (event) {
        if (!(xhr.status >= 200 && xhr.status < 300)) {
            var error = new Error(xhr.status + " " + xhr.statusText);
            onError(error, { event: event, xhr: xhr, file: file });
            return;
        }
        var text = xhr.responseText || xhr.response;
        var result;
        try {
            result = JSON.parse(text);
        }
        catch (err) {
            result = text;
        }
        onSuccess(result, { event: event, xhr: xhr, file: file });
    };
    xhr.onerror = function (event) {
        return onError(new Error("Http Request Error"), { event: event, xhr: xhr, file: file });
    };
    if (onProgress && xhr.upload) {
        xhr.upload.onprogress = function (event) {
            if (event.lengthComputable && event.total) {
                onProgress({
                    total: event.total,
                    loaded: event.loaded,
                    percent: (event.loaded / event.total) * 100,
                }, { event: event, xhr: xhr, file: file });
            }
        };
    }
    Object.keys(data).forEach(function (key) {
        formData.append(key, data[key]);
    });
    formData.append(filename, file);
    xhr.open(method, action, true);
    xhr.withCredentials = withCredentials;
    Object.keys(headers).forEach(function (key) {
        xhr.setRequestHeader(key, headers[key]);
    });
    xhr.send(send(file, formData));
    return xhr;
}
exports.upload = upload;
//# sourceMappingURL=uploadFile.js.map